<template>
  <div>
    <div v-if="$auth.policies['view-dishes']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Danh sách món ăn"
            :link="[
              {
                text: 'Món ăn',
                href: '../dishes'
              }
            ]"
          />
        </div>
        <div class="flex-center">
          <v-btn depressed dark color="primary" @click="newDialog = !newDialog"> Thêm món ăn </v-btn>
        </div>
      </div>

      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="type"
              :items="dishTypes"
              clear-icon="mdi-close"
              item-text="title"
              item-value="value"
              label="Nhóm món"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-btn dark outlined class="search-button" @click="onFilterChange">
              Tìm kiếm
            </v-btn>
            <v-spacer />
          </v-col>
        </v-row>
      </v-card>

      <v-card outlined class="mx-4 elevation-0">
        <DishDataTable ref="dishDataTable" />
      </v-card>
      <DishNewDialog :state="newDialog" />
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapGetters } from 'vuex'
import DishDataTable from '@/modules/dish/DishDataTable.vue'

export default {
  components: {
    Breadcrumbs,
    DishDataTable,
    DishNewDialog: () => import('@/modules/dish/DishNewDialog.vue')
  },
  props: {},
  data() {
    return {
      newDialog: false,
      type: ''
    }
  },
  computed: {
    ...mapGetters('constant', ['dishTypes'])
  },
  methods: {
    async refresh(query) {
      this.$refs.dishDataTable.refresh(query)
    },
    onFilterChange() {
      this.refresh({
        type: this.type
      })
    }
  },
  created() {
    this.status = this.statusDefault
  }
}
</script>
<style scoped></style>
